"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModalHeader = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const free_solid_svg_icons_1 = require("@fortawesome/free-solid-svg-icons");
const react_fontawesome_1 = require("@fortawesome/react-fontawesome");
const alert_dialog_1 = require("@reach/alert-dialog");
require("@reach/dialog/styles.css");
const visually_hidden_1 = __importDefault(require("@reach/visually-hidden"));
const react_1 = require("react");
const Box_1 = require("../Box");
const Button_1 = require("../Button");
const Flex_1 = require("../Flex");
const Modal_1 = require("../Modal");
function ModalHeader(_a) {
    var { children } = _a, props = __rest(_a, ["children"]);
    const { onDismiss } = react_1.useContext(Modal_1.SingleModalContext);
    return (jsx_runtime_1.jsxs(Flex_1.Flex, Object.assign({ alignItems: "center" }, props, { children: [jsx_runtime_1.jsx(alert_dialog_1.AlertDialogLabel, { children: typeof children === 'string' ? jsx_runtime_1.jsx("h4", { children: children }, void 0) : children }, void 0),
            jsx_runtime_1.jsx(Box_1.Box, Object.assign({ ml: "auto" }, { children: jsx_runtime_1.jsxs(Button_1.Button, Object.assign({ backgroundColor: "transparent", color: "inherit", _hover: { backgroundColor: 'rgba(125,125,125,0.2)' }, onClick: onDismiss }, { children: [jsx_runtime_1.jsx(visually_hidden_1.default, { children: "Close" }, void 0),
                        jsx_runtime_1.jsx("span", Object.assign({ "aria-hidden": true }, { children: jsx_runtime_1.jsx(react_fontawesome_1.FontAwesomeIcon, { icon: free_solid_svg_icons_1.faTimes }, void 0) }), void 0)] }), void 0) }), void 0)] }), void 0));
}
exports.ModalHeader = ModalHeader;
//# sourceMappingURL=index.js.map